import React, { useEffect, useRef, useState } from "react";
import { LoadingContainer, LoadingContent, LoadingProgress, LoadingText, LoadingLogo, LoadingBar, LoadingSpinner, Particles } from "../../Styled/Loading/Loading.styled";
import anime from "animejs";
import Lottie from "lottie-react";
import animationData from "../../assiat/laptopCoffe.json";

const Loading = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const loadingRef = useRef(null);
  const textRef = useRef(null);
  const progressRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Animate text entrance
    if (textRef.current) {
      anime({
        targets: textRef.current,
        opacity: [0, 1],
        translateY: [20, 0],
        duration: 800,
        easing: "easeOutQuad",
      });
    }

    // Simulate loading progress
    let currentProgress = 0;
    const progressInterval = setInterval(() => {
      currentProgress += Math.random() * 15;
      if (currentProgress > 100) {
        currentProgress = 100;
        clearInterval(progressInterval);
        
        // Complete animation after progress reaches 100%
        setTimeout(() => {
          if (containerRef.current) {
            anime({
              targets: containerRef.current,
              opacity: [1, 0],
              scale: [1, 0.95],
              duration: 600,
              easing: "easeInQuad",
              complete: () => {
                if (onComplete) {
                  onComplete();
                }
              },
            });
          }
        }, 500);
      }
      setProgress(currentProgress);
    }, 100);

    // Animate particles
    if (loadingRef.current) {
      const particles = loadingRef.current.querySelectorAll(".particle");
      anime({
        targets: particles,
        translateY: [
          { value: -100, duration: 2000 },
          { value: 100, duration: 2000 },
        ],
        translateX: [
          { value: -50, duration: 1500 },
          { value: 50, duration: 1500 },
        ],
        opacity: [
          { value: 0, duration: 500 },
          { value: 0.6, duration: 1000 },
          { value: 0, duration: 500 },
        ],
        scale: [0, 1, 0],
        duration: 3000,
        delay: anime.stagger(200),
        loop: true,
        easing: "easeInOutQuad",
      });
    }

    return () => clearInterval(progressInterval);
  }, [onComplete]);

  return (
    <LoadingContainer ref={containerRef}>
      <Particles ref={loadingRef}>
        {[...Array(12)].map((_, i) => (
          <div key={i} className="particle" />
        ))}
      </Particles>
      
      <LoadingContent>
        <LoadingLogo>
          <Lottie
            animationData={animationData}
            loop={true}
            autoplay={true}
          />
        </LoadingLogo>
        
        <LoadingText ref={textRef}>
          <h2>Welcome</h2>
          <p>Loading amazing experience...</p>
        </LoadingText>

        <LoadingBar>
          <LoadingProgress 
            ref={progressRef}
            style={{ width: `${progress}%` }}
          />
        </LoadingBar>
        
        <LoadingSpinner>
          <div className="spinner-ring" />
          <div className="spinner-ring" />
          <div className="spinner-ring" />
        </LoadingSpinner>
      </LoadingContent>
    </LoadingContainer>
  );
};

export default Loading;

